/* eslint-disable react/jsx-fragments */
/** @jsx jsx */
import { Fragment, } from 'react';
import { jsx, } from '@emotion/core';
import styled from '@emotion/styled';
import { colors, typography, } from '@argo/principles';
import OneStar from './OneStar';
import { Panels, } from '../../sew-widget/components/Constants';
import {Link} from '@argo/ui-elements';

const FontVehicleYearMakeModelHeader = styled.div`
  font-size: 18px;
  line-height: 24px;
  font-family: ${typography.family.montserrat};
  color: ${colors.primary.black};
  font-weight: ${typography.weight.semiBold};
`;

const FontVehicleTrimHeader = styled.div`
  font-size: 12px;
  line-height: 18px;
  font-family: ${typography.family.opensans};
  color: ${colors.primary.charcoal};
  font-weight: ${typography.weight.light};

  display: flex;
  justify-content: space-between;
`;

const VehicleInfo = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const VehicleYearMakeModel = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
  padding: 20px 0px 0px;
  width: 100%;
`;

const VehicleTrim = styled.div`
  display: flex;
  flex-direction: column;
  height: 41px;
  padding: 7px 0 16px;
  width: 100%;
`;

const YMMT = styled.div`
  border-bottom: 1px solid #ddd;
`;

const RatingsInfo = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  justify-content: space-between;
  padding: 7px 0 12px 0;
  max-width: 280px;
`;


export default ({ vehicleTitle, vehicleTrimName, consumerReviewAndRating, expertReviewAndRating, requestedPanels, isOptedOutOfEWBacklink=false}: any,) => {
  let displayConsumerRating = false;
  let displayExpertRating = false;

  if (requestedPanels.includes(Panels.CONSUMER_RATINGS,)) {
    if (consumerReviewAndRating && consumerReviewAndRating.consumerRating && consumerReviewAndRating.consumerRating.overallRating && (consumerReviewAndRating.consumerRating.overallRating.length > 0)) {
      displayConsumerRating = true;
    }
  }
  if (requestedPanels.includes(Panels.EXPERT_RATINGS,)) {
    if (expertReviewAndRating && expertReviewAndRating.expertRating && expertReviewAndRating.expertRating.overallRating && (expertReviewAndRating.expertRating.overallRating.length > 0)) {
      displayExpertRating = true;
    }
  }

  return (
    <Fragment>
      <VehicleInfo id="vehicleInfo">
        <YMMT>
          <VehicleYearMakeModel>
            <FontVehicleYearMakeModelHeader id="VehicleYearMakeModel">
              {vehicleTitle}
            </FontVehicleYearMakeModelHeader>
          </VehicleYearMakeModel>
          <VehicleTrim>
            <FontVehicleTrimHeader >
              <div id="VehicleTrim">
                {vehicleTrimName}
              </div>
              {
                !isOptedOutOfEWBacklink &&
                (displayConsumerRating || displayConsumerRating) && //this is so the boolean doesn't load prematurely
                <Link id="RatingsDescriptionLink" href="https://www.kbb.com/cars/#rating-content" target="_blank"> 
                  What Our Ratings Mean 
                </Link>
              }
            </FontVehicleTrimHeader>
          </VehicleTrim>
        </YMMT>
        <RatingsInfo>
          { displayExpertRating ? (
            <div id="expertStarLabel">
              <OneStar label="Expert" rating={expertReviewAndRating.expertRating.overallRating} />
            </div>
          ) : ''}
          { displayConsumerRating ? (
            <div id="consumerStarLabel">
              <OneStar label="Consumer" rating={consumerReviewAndRating.consumerRating.overallRating} />
            </div>
          ) : ''}
        </RatingsInfo>
      </VehicleInfo>
    </Fragment>
  );
};
